import {Client} from '../../../graphql/types'

const AFFILIATE_IDS = [36348, 36370]

export const overrideFor36348And36370 = (accounts: any[], client: Client) => {
  if (!client.affiliateId) return accounts

  if (!AFFILIATE_IDS.includes(client.affiliateId)) return accounts

  return accounts.filter((account) => !['black', 'raw', 'mt5Raw', 'mt5Vip'].includes(account.accountSubtype))
}
